import React from "react";
import * as env from "shared/env";
import { LegacySettingsMortgageCalculator } from "./legacy";
import { RefreshedSettingsMortgageCalculator } from "./refreshed";

// MAX-3629: the refreshed Mortgage Calculator page is gated behind the REFRESH_DESIGNS dev flag.
// When the flag is off, the legacy "Mortgage Calc Settings" page renders unchanged.
export const SettingsMortgageCalculator: React.FC<any> = (props) =>
	env.refreshDesignsDev ? (
		<RefreshedSettingsMortgageCalculator {...props} />
	) : (
		<LegacySettingsMortgageCalculator {...props} />
	);
